module.exports = __webpack_public_path__ + "img/ctrl-c-stub-up--i.2704a4d5.svg";